<template>
  <v-form
    class="form-grid"
    id="billing-details-grid"
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <div class="ml-6 mr-6 mt-6 mb-6">
      <h2 class="mt-4 mb-4">{{ title }}</h2>
      <p style="grid-area: paymentInformation">
        Some tests are eligible for Medicare. Out of pocket costs apply for many
        tests. Please contact Customer Care on
        <a
          style="color: inherit; text-decoration: none;"
          href="tel:+611300118247"
          >+61 1300 118 247</a
        >
        or
        <a
          target="_blank"
          style="color: inherit; text-decoration: none;"
          href="https://vcgs.org.au"
          >vcgs.org.au</a
        >
        for more details.
      </p>

      <v-row v-if="showSendBillTo">
        <v-col>
          <span class="text-title">Send bill to*</span>
          <v-select
            v-model="store.deligateBillingAddress"
            id="billing.sendBillTo"
            :items="sendBillToList"
            item-text="displayText"
            item-value="value"
            outlined
            :rules="showSendBillTo ? ruleNotNull : []"
            hide-details="auto"
          ></v-select>
        </v-col>
      </v-row>
      <v-alert
        text
        color="error"
        type="error"
        class="top-spaced-item multi-line custom-alert mb-6"
        v-if="store.deligateBillingAddress === 'PATIENT'"
      >
        <span>
          By selecting this option, you acknowledge that financial consent has
          been obtained from the patient/family to cover the cost indicated
          below.
          <br />
          <strong>The patient will be sent an SMS link to make payment.</strong>
        </span>
      </v-alert>
      <v-row v-if="showBillingDetails">
        <v-col>
          <span class="text-title">Billing name*</span>
          <v-text-field
            v-model="billingName"
            id="billing.billingName"
            outlined
            :rules="showBillingDetails ? ruleNotNull : []"
            hide-details="auto"
          ></v-text-field
        ></v-col>
      </v-row>
      <v-row v-if="showBillingDetails">
        <v-col>
          <span class="text-title">Billing address*</span>
          <v-textarea
            v-model="billingAddress"
            id="billing.billingAddress"
            outlined
            :rules="showBillingDetails ? ruleNotNull : []"
            hide-details="auto"
          ></v-textarea>
        </v-col>
      </v-row>

      <TotalPriceAlert
        :showReanalysisAlert="showReanalysisAlert"
        :showVariantReviewAlert="showVariantReviewAlert"
        :price="totalPrice"
        billingDetail
      />
    </div>
  </v-form>
</template>

<script>
import FormRulesMixin from "../mixins/FormRulesMixin";
import DropDownMixin from "../mixins/DropDownMixin";
import { useSectionStore } from "../store/SectionStore";
import TotalPriceAlert from "./common/TotalPriceAlert.vue";
export default {
  name: "",
  mixins: [FormRulesMixin, DropDownMixin],
  props: {
    title: String,
    patientdata: Object,
    totalPrice: Number,
    populatekeys: Array,
    selectedTests: Array,
    displayBillingAddress: Boolean,
    showReanalysisAlert: Boolean,
    showVariantReviewAlert: Boolean,
  },
  components: { TotalPriceAlert },
  setup() {
    const store = useSectionStore();
    return {
      store,
    };
  },
  watch: {
    totalPrice: function() {
      useSectionStore().deligateBillingAddress =
        this.totalPrice === 0 ? "MEDICARE" : null;
    },
  },
  computed: {
    showSendBillTo: function() {
      return this.displayBillingAddress ? true : this.totalPrice !== 0;
    },
    showBillingDetails: function() {
      if (this.totalPrice !== 0 || this.displayBillingAddress) {
        return useSectionStore().deligateBillingAddress === "OTHER";
      } else return false;
    },
  },
  data: () => ({
    sendBillTo: null,
    billingName: "",
    billingAddress: "",
  }),
  methods: {
    transferData: function() {
      return {
        sendBillTo:
          useSectionStore().deligateBillingAddress !== null
            ? useSectionStore().deligateBillingAddress
            : "MEDICARE",
        billingName: this.billingName,
        billingAddress: this.billingAddress,
      };
    },
  },
};
</script>

<style scoped>
.v-application .v-alert.fill-red {
  background-color: red !important;
  border: 1px solid #ff0000 !important;
}

.v-application .v-alert.fill-red .v-alert__content {
  color: #bf0000 !important;
}
</style>
